<lcs-loading-overlay [show]="callState | lcsCallState: 'loading'">
  <div class="compact-register-wrapper">
    <div class="compact-register-header flex-container space-between">
      <div class="compact-register-filter-area">
        @if (hasSearchInput) {
          <mat-form-field>
            <input
              autocomplete="off"
              type="text"
              #search
              matInput
              [ngModel]="searchText"
              (ngModelChange)="onSearchTextChange($event)"
              placeholder="Search {{ name }}s"
              name="search-input"
              />
              <mat-icon matSuffix class="list-search-icon">search</mat-icon>
            </mat-form-field>
          }
          <ng-content select="ndt-register-quick-filter"></ng-content>
        </div>
        @if (showCreate) {
          <button
            class="create-btn"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onCreate()"
            title="Create {{ name }}"
            >
            <span>Add {{ name }}</span>
          </button>
        }
      </div>
      <div class="settings-table-wrapper" cdkScrollable>
        <ng-content></ng-content>
        <lcs-table-footer
          [callState]="callState"
          [pagingCallState]="pagingCallState"
          [itemCount]="totalCount"
          [hasNextPage]="hasNextPage"
          (loadMore)="onLoadMore()"
          >
          No {{ name | lowercase }}s found.
        </lcs-table-footer>
      </div>
    </div>
  </lcs-loading-overlay>
